import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import { TextInput } from 'react-admin';
import { useWatch, useFormState, useFormContext } from 'react-hook-form';

import { normalizer } from './utils';

const StyledInputAdornment = styled(InputAdornment)(({ theme }) => ({
    display: 'inline-flex',
    marginRight: 0,
    color: theme?.palette?.text?.disabled || 'rgba(0, 0, 0, 0.38)',
}));

const HOSTNAME = process.env.FRONTEND_HOST || `${window.location.protocol}//${window.location.hostname}`;

const SlugInput = ({ pageUrlPart, source, variant = 'filled', ...props }) => {
    const urlPrefix = `${HOSTNAME}/${pageUrlPart}/`;
    const { control } = useFormContext();
    const value = useWatch({ name: source, control });
    const { dirtyFields } = useFormState();

    const prefix = (
        <StyledInputAdornment
            disableTypography
            disablePointerEvents
            position="start"
        >
            { urlPrefix }
        </StyledInputAdornment>
    );

    const isDirty = dirtyFields[source];

    let suffix = null;

    if (!isDirty && value) {
        suffix = (
            <InputAdornment position="end">
                <Button
                    href={`${urlPrefix}${value}`}
                    target="_blank"
                    size="small"
                    color="primary"
                >
                    View URL
                </Button>
            </InputAdornment>
        );
    }

    const inputProps = {
        startAdornment: prefix,
        endAdornment: suffix,
    };

    return (
        <TextInput
            {...props}
            source={source}
            variant={variant}
            InputProps={inputProps}
            parse={normalizer}
        />
    );
};

SlugInput.propTypes = {
    pageUrlPart: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    variant: PropTypes.string,
};

export default React.memo(SlugInput);
